<template>
    <el-dialog class="haveTable" title="版本管理" width="95%" :close-on-click-modal="false" :visible.sync="visible">
        <div class="el-table-container">
            <el-form size="small" :inline="true" ref="searchForm" :model="searchForm"
                     @keyup.enter.native="refreshList(1)">
                <el-form-item prop="basicName" label="关键字查询：">
                    <el-input v-model.trim="searchForm.basicName" maxlength="50" placeholder="请输入变更前后元数据名称"
                              clearable></el-input>
                </el-form-item>
                <el-form-item prop="changeType" label="变更类型：">
                    <el-select v-model="searchForm.changeType" placeholder="请选择变更类型" clearable>
                        <el-option
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                v-for="item in $dictUtils.getDictList('edition_type')">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="startDate" label="变更时间：">
                    <el-date-picker v-model="time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                                    format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="refreshList(1)" size="small"
                               icon="el-icon-search">
                        查询
                    </el-button>
                    <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%" @sort-change="sortChange"
                    class="table" ref="multipleTable" border>
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createByUserName" label="变更人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" label="变更时间" sortable show-overflow-tooltip></el-table-column>
                <el-table-column prop="changeType" label="变更类型">
                    <template slot-scope="{row}">
                        {{$dictUtils.getDictLabel("edition_type", row.changeType ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="basicType" label="元数据类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{$dictUtils.getDictLabel("basic_type", row.basicType ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="basicId" label="元数据ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="beforeBasicName" label="变更前数据">
                    <el-table-column prop="beforeBasicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="beforeBasicParentName" label="父级" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="startAssemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="beforeBasicEnable" label="启用状态" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            {{$dictUtils.getDictLabel("public_state", row.beforeBasicEnable ,'')}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="afterBasicName" label="变更后数据">
                    <el-table-column prop="afterBasicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="afterBasicParentName" label="父级" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="endAssemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="afterBasicEnable" label="启用状态" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            {{$dictUtils.getDictLabel("public_state", row.afterBasicEnable ,'')}}
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size" @pagination="refreshList"/>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
            <el-button size="small" type="primary" @click="exportData()" v-noMoreClick :disabled="loading">导出</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                searchForm: {
                    basicName: '',
                    changeType: '',
                    startDate: '',
                    endDate: '',
                    order: '',
                    current: 1,
                    size: 20,
                },
                time: [],
                dataList: [],
                total: 0,
                loading: false,
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.reset()
                })
            },
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                let p = JSON.parse(JSON.stringify(this.searchForm))
                p.startDate = this.time && this.time.length ? this.time[0] : ''
                p.endDate = this.time && this.time.length ? this.time[1] : ''
                this.$axios(this.api.metadata.metadatachangerecordList, p, 'post').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    }
                })
            },
            // 导出
            exportData() {
                if(!this.dataList.length) {
                    this.$message.warning('暂无可导出的数据')
                    return
                }
                let p = JSON.parse(JSON.stringify(this.searchForm))
                p.startDate = this.time && this.time.length ? this.time[0] : ''
                p.endDate = this.time && this.time.length ? this.time[1] : ''
                this.exportExcel(this.api.metadata.listExport, p, '元数据管理版本管理', 'post')
            },
            // 列表排序
            sortChange(column) {
                this.searchForm.order = column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''),
                this.refreshList()
            },
            // 重置
            reset() {
                this.time = []
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        }
    }
</script>

<style scoped>

</style>
